"use strict";import{Dropzone as e}from"./src/Dropzone.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-dropzone",e);
//# sourceMappingURL=sp-dropzone.js.map
